import analytics from "../analytics/analytics.js";
const extractQs = (urlString)=>{
    try {
        const urlObj = new URL(urlString);
        return urlObj.search;
    } catch (e) {
        analytics.logError(e);
        return '';
    }
};
export { extractQs };
